/* eslint-disable max-len */
export const groupChampionsByLevel = (data) => {
  const groupByLevel = (champions) => {
    return champions.reduce((acc, champion) => {
      const { championLevel } = champion

      if (!acc[championLevel]) acc[championLevel] = []

      acc[championLevel].push(champion)

      // Sort champions by points within each level
      acc[championLevel].sort((a, b) => b.championPoints - a.championPoints)

      return acc
    }, {})
  }

  return groupByLevel(data)
}

export const getTotalRemainingPoints = (sortedChampions) => {
  let points = 0
  for (const { championLevel, championPoints } of sortedChampions) {
    if (championLevel < 5) {
      points += 75600 - championPoints
    }
  }
  return points
}

export const remainingTokens = ({ championLevel, tokensEarned }) => {
  const maxTokens = championLevel >= 9 ? 2 : 1
  return Math.min(tokensEarned / maxTokens, 1)
}

export const remainingLevelPercent = ({ championLevel, championPointsUntilNextLevel, championPointsSinceLastLevel }) => {
  return championLevel === 0
    ? 0
    : championPointsUntilNextLevel > 0
      ? championPointsSinceLastLevel /
                (championPointsUntilNextLevel + championPointsSinceLastLevel)
      : 1
}
